<template>
  <v-form-create
    v-if="access.create_fee"
    large
    name="fee_create"
    top_title="create_fee"
  >
    <v-form ref="form" v-model="valid">
      <v-layout row>
        <v-flex md3 px-2>
          <v-autocomplete
            v-model="current_fee.type"
            :items="types"
            :label="$t('type')"
            item-value="value"
            item-text="name"
            ref="type"
            :rules="[fieldRules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex md3 px-2>
          <v-autocomplete
            v-model="current_fee.service"
            :items="stores"
            :label="$t('store')"
            item-value="_id"
            item-text="name"
            ref="service"
            :rules="[fieldRules.required]"
          ></v-autocomplete>
        </v-flex>

        <v-flex md6 px-2>
          <v-autocomplete
            v-if="current_fee.type == 'company_to_fees'"
            v-model="current_fee.supplier"
            :items="all_suppliers"
            :label="$t('supplier')"
            item-value="_id"
            item-text="supplier_name"
            ref="supplier"
            :rules="[fieldRules.required]"
          ></v-autocomplete>
          <v-autocomplete
            v-else-if="current_fee.type == 'salary'"
            v-model="current_fee.employee"
            :items="all_employees"
            :label="$t('employee')"
            item-value="_id"
            item-text="name"
            ref="employee"
            :rules="[fieldRules.required]"
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md6 px-2>
          <v-select
            v-model="current_fee.option_id"
            :label="$t('option')"
            item-value="_id"
            item-text="name"
            :items="options"
          />
        </v-flex>
        <v-flex md6 px-2>
          <v-text-field
            v-model="current_fee.comment"
            autocomplete="off"
            :label="$t('comment')"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md6 px-2>
          <v-autocomplete
            v-model="current_fee.amount_type"
            :items="amount_types"
            item-text="name"
            item-value="value"
            :label="$t('amount_type')"
            ref="amount_type"
            :rules="[fieldRules.required]"
          ></v-autocomplete>
        </v-flex>
        <v-flex md4 px-2>
          <vuetify-money
            v-model="current_fee.currency_amount"
            :options="
              current_fee.currency == 'usd' ? moneyOptionsUSD : moneyOptions
            "
            :label="$t('amount')"
            ref="amount"
            :rules="[fieldRules.required]"
          ></vuetify-money>
        </v-flex>
        <v-flex md2 px-2>
          <v-select
            v-model="current_fee.currency"
            :label="$t('currency')"
            :items="transfer_currencies"
            :append-icon="null"
            ref="currency"
            :rules="[fieldRules.require]"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-form>
    <template #action>
      <v-btn text v-on:click="$to('/inventory/fees')">{{ $t("cancel") }}</v-btn>
      <v-btn
        text
        :loading="loading_fee"
        color="success"
        @click="createConsumption"
        :disabled="!valid"
        >{{ $t("save") }}</v-btn
      >
    </template>
  </v-form-create>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import Suppliers from "../../mixins/inventory/supplier";
import Employees from "../../mixins/employees/workgroup";
import Options from "../../mixins/settings/options";
const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  mixins: [Services, AllSuppliers, Employees, Options],
  data: () => ({
    valid: false,
    current_fee: {
      type: null,
      service: null,
      supplier: null,
      employee: null,
      comment: "",
      amount_type: null,
      currency_amount: null,
      currency: "uzs",
    },
    types: [
      {
        name: "Fees",
        value: "fees",
      },
      {
        name: "One time fees",
        value: "one_time_fees",
      },
      {
        name: "Salary",
        value: "salary",
      },
      {
        name: "Company to fees",
        value: "company_to_fees",
      },
    ],
    amount_types: [
      {
        name: "Cash",
        value: "cash",
      },
      {
        name: "Card",
        value: "card",
      },
    ],
    noAllStores: true,
    loading_fee: false,
  }),
  methods: {
    async createConsumption() {
      this.loading_fee = true;
      const res = this.$communicator.then(
        this,
        await this.$communicator("create_consumption", {
          params: this.current_fee,
        })
      );
      if (res) {
        this.$toast.success("Success", { timeout: 2000 });
        this.$router.push("/inventory/fees").catch(() => {});
      }
      this.loading_fee = false;
    },
  },
  mounted() {
    this.optionsGet();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
